<template>
  <div class="ptownflags">
    <div class="panel panel-primary">
      <!-- <div class="panel-heading">Ptown Flags</div> -->
      <div class="panel-body">

      </div>
    </div>
    <div class="gal">
      <div v-for="item in images">
        <img v-bind:src="item.url" alt="image">
      </div>
    </div>

    <div>
      <div class="box-white" style="background-color: #fff">
        <h5>Colors <i>decoded</i></h5>
      </div>
      <div class="box" style="background-color: #b22234">
        <h5>Hardiness and Valor</h5>
      </div>
      <div class="box" style="background-color: #e40303">
        <h5>Life</h5>
      </div>
      <div class="box" style="background-color: #ff8c00">
        <h5>Healing</h5>
      </div>
      <div class="box-yellow">
        <h5>Sunlight</h5>
      </div>
      <div class="box-white" style="background-color: #fff">
        <h5>Purity and Innocence</h5>
      </div>
      <div class="box" style="background-color: #008026">
        <h5>Nature</h5>
      </div>
      <div class="box" style="background-color: #3c3b6e">
        <h5>Vigilance, Perseverance and Justice</h5>
      </div>
      <div class="box" style="background-color: #004dff">
        <h5>Harmony and Peace</h5>
      </div>
      <div class="box" style="background-color: #750787">
        <h5>Spirit</h5>
      </div>
    </div>

    <div class="sources">
      <p><b><i>Sources</i></b> <span><a href="https://www.pbs.org/a-capitol-fourth/history/old-glory/">History of the
            American Flag &mdash; <i>PBS</i></a></span>
        &bull;
        <span><a href="https://en.wikipedia.org/wiki/Rainbow_flag">Rainbow Flag &mdash; <i>Wikipedia</i></a></span>
        &bull;
        <span><a href="https://en.wikipedia.org/wiki/Rainbow_flag_(LGBT_movement)">Rainbow Flag LGBT Movement &mdash;
            <i>Wikipedia</i></a></span>

      </p>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'PtownFlags',
    data() {
      return {
        images: [
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_Verticle_1.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/USFlag.svg') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_02.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_11.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_01.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_04.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_03.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_05.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_06.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_07.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PrideFlag.svg') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_08.png') },
          { title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_09.png') },
        ]
      }
    },
  }
</script>

<!-- https://upload.wikimedia.org/wikipedia/commons/4/48/Gay_Pride_Flag.svg -->
<!--
{ title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/USFlag.svg') }, 
{ title: 'Cape Tip Estates', content: 'note 4 content', url: require('../assets/images/flags/PtownFlags_09.png') },
-->

<style scoped>
  .box {
    height: 3rem;
    width: auto;
    text-align: center;
    color: white;
    padding-top: .5rem;
  }

  .box-yellow {
    height: 3rem;
    width: auto;
    text-align: center;
    background-color: #ffed00;
    color: lightslategray;
    padding-top: .5rem;
  }

  .box-white {
    height: 3rem;
    width: auto;
    text-align: center;
    /* border-style: solid;
    border-width: 1px;
    border-color: lightslategray; */
    color: lightslategray;
    padding-top: .5rem;
  }

  .sources {
    font-size: .8rem;
    margin-bottom: 2rem;
  }

  .gal {
    margin-top: 1rem;
    -webkit-column-count: 3;
    /* Chrome, Safari, Opera */
    -moz-column-count: 3;
    /* Firefox */
    column-count: 3;
  }

  .gal img {
    width: 100%;
    padding: 0px 0;
    margin-bottom: 1rem;
  }

  .gal h2 {
    margin: 0 0 0;
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
    color: white;
    background-color: #FBB315;
  }

  .gal .request-detail {
    border: #FBB315;
    border-style: solid;
    border-width: 1px;
    padding: 4px;
    margin-bottom: 10px;
  }

  .gal p {
    margin: 10px 0 0;
    padding: 0;
    font-size: 14px;
  }

  .gal .request-date {
    font-size: 14px;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    .gal {
      -webkit-column-count: 2;
      /* Chrome, Safari, Opera */
      -moz-column-count: 2;
      /* Firefox */
      column-count: 2;
    }
  }

  @media (max-width: 480px) {
    .gal {
      -webkit-column-count: 1;
      /* Chrome, Safari, Opera */
      -moz-column-count: 1;
      /* Firefox */
      column-count: 1;
    }
  }
</style>